import React from "react";

const BlueHeading = ({
  lineClassOne,
  lineClassTwo,
  text,
  textClass,
  className = "",
}) => {
  return (
    <>
      <div className={`flex items-center gap-2 max-sm:gap-1 ${className}`}>
        <div
          className={`${lineClassOne} w-16 max-sm:w-10 h-0.5 bg-[#2920D2]`}></div>
        <p
          className={`text-base font-bold leading-[150%] ff-jakarta whitespace-nowrap max-sm:text-sm uppercase text-[#2920D2] ${textClass}`}>
          {text}
        </p>
        <div
          className={`${lineClassTwo} w-16 h-0.5 max-sm:w-10 bg-[#2920D2]`}></div>
      </div>
    </>
  );
};

export default BlueHeading;
